import type { ErrorType } from "@/api/utils";
import type { ApiError } from "@/utils/fetching";
import { toast } from "@st-marketplace/ui";
import { useCallback } from "react";
import { useTranslation } from "./useTranslation";

type translationErrorPath = `openApi.error.${ErrorType}`;

function useApiError() {
	const { t } = useTranslation();

	const getErrorMessage = useCallback(
		(error: ApiError) => {
			if (
				error.body &&
				typeof error.body === "object" &&
				"type" in error.body &&
				error.body.type
			) {
				const errorPath: translationErrorPath = `openApi.error.${error.body.type}`;
				return t(errorPath);
			}
			return t("error.unexpected");
		},
		[t],
	);

	const toastApiError = useCallback(
		(error: ApiError) => {
			const message = getErrorMessage(error);
			toast.error(message);
		},
		[getErrorMessage],
	);

	const getErrorInterface = useCallback(
		(error: ApiError) => {
			return new Error(getErrorMessage(error));
		},
		[getErrorMessage],
	);

	return {
		toastApiError,
		getErrorMessage,
		getErrorInterface,
	};
}

export default useApiError;
